/* Glimmer — catálogo de "Todos os produtos": categorias, marca e ordenação no navegador.
   Lê todos os produtos de /collections/all/products.json (de 250 em 250), ordena por relevância
   (vendas + visualizações, da API) e mostra 24 por vez, carregando mais sozinho ao rolar. */
(function () {
  var raiz = document.querySelector('[data-glimmer-catalogo]');
  if (!raiz) { return; }
  var $ = function (s) { return raiz.querySelector(s); };
  var FATOR = parseFloat(raiz.getAttribute('data-fator')) || 0.9033;
  var PARCELAS = parseInt(raiz.getAttribute('data-parcelas'), 10) || 6;
  var POR_VEZ = 24;
  var produtos = [];
  var listaAtual = [];
  var relevancia = { vendas: {}, vistas: {} };   // unidades vendidas e visualizações por produto
  var estado = { q: '', categoria: '', marca: '', ordem: 'relevancia', mostrar: POR_VEZ, todasCats: false };

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var dinheiro = function (v) { return Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); };
  var sem = function (s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
  var cap = function (s) { s = String(s || '').trim(); return s ? s.charAt(0).toUpperCase() + s.slice(1) : ''; };
  var foto = function (src) { return src ? src.replace(/(\.\w+)(\?|$)/, '_480x480$1$2') : ''; };

  function preparar(p) {
    var partes = String(p.title || '').split(' - ');
    var marca = (partes.length >= 2 ? partes[0] : p.vendor || '').trim();
    var nome = partes.length >= 3 ? partes.slice(2).join(' - ') : (partes.length === 2 ? partes[1] : p.title);
    var categoria = cap(p.product_type || (partes.length >= 3 ? partes[1] : ''));
    var precos = (p.variants || []).map(function (v) { return parseFloat(v.price); }).filter(function (n) { return n > 0; });
    var cores = (p.variants || []).map(function (v) { return v.title; }).filter(function (t) { return t && t !== 'Default Title'; }).join(' ');
    return {
      handle: p.handle, marca: marca, nome: nome, categoria: categoria, preco: precos.length ? Math.min.apply(null, precos) : 0,
      varios: precos.length > 1 && Math.max.apply(null, precos) !== Math.min.apply(null, precos),
      img: p.images && p.images[0] && p.images[0].src, data: new Date(p.published_at || p.created_at).getTime() || 0,
      busca: sem([marca, nome, categoria, cores].join(' '))
    };
  }

  function buscar(pagina, todos) {
    return fetch('/collections/all/products.json?limit=250&page=' + pagina).then(function (r) { return r.json(); }).then(function (d) {
      var l = (d && d.products) || []; todos = todos.concat(l);
      return l.length === 250 && pagina < 20 ? buscar(pagina + 1, todos) : todos;
    });
  }

  function lerUrl() {
    var u = new URLSearchParams(location.search);
    estado.q = u.get('q') || '';
    estado.categoria = u.get('categoria') || '';
    estado.marca = u.get('marca') || '';
    estado.ordem = u.get('ordem') || 'relevancia';
  }
  function gravarUrl() {
    var u = new URLSearchParams(location.search);
    ['q', 'categoria', 'marca'].forEach(function (k) { if (estado[k]) { u.set(k, estado[k]); } else { u.delete(k); } });
    if (estado.ordem && estado.ordem !== 'relevancia') { u.set('ordem', estado.ordem); } else { u.delete('ordem'); }
    var s = u.toString();
    history.replaceState(null, '', location.pathname + (s ? '?' + s : ''));
  }

  function filtrados(ignorarCategoria) {
    var termos = sem(estado.q).split(/\s+/).filter(Boolean);
    return produtos.filter(function (p) {
      if (!ignorarCategoria && estado.categoria && p.categoria !== estado.categoria) { return false; }
      if (estado.marca && p.marca !== estado.marca) { return false; }
      return termos.every(function (t) { return p.busca.indexOf(t) >= 0; });
    });
  }

  // Relevância: cada unidade vendida vale 10 visualizações (compra pesa mais que olhar).
  function pontuacao(p) { return (Number(relevancia.vendas[p.handle]) || 0) * 10 + (Number(relevancia.vistas[p.handle]) || 0); }
  function ordenar(lista) {
    var o = estado.ordem;
    return lista.slice().sort(function (a, b) {
      if (o === 'menor') { return a.preco - b.preco; }
      if (o === 'maior') { return b.preco - a.preco; }
      if (o === 'az') { return (a.marca + a.nome).localeCompare(b.marca + b.nome, 'pt-BR'); }
      if (o === 'relevancia') { return (pontuacao(b) - pontuacao(a)) || (b.data - a.data); }
      return b.data - a.data;
    });
  }

  function chips() {
    // Categorias existentes com a marca escolhida, das que têm mais produtos para as que têm menos (sem mostrar números).
    var cont = {};
    filtrados(true).forEach(function (p) { if (p.categoria) { cont[p.categoria] = (cont[p.categoria] || 0) + 1; } });
    var cats = Object.keys(cont).sort(function (a, b) { return cont[b] - cont[a]; });
    var LIMITE = 10;
    var html = '<button type="button" class="glimmer-cat__chip' + (!estado.categoria ? ' is-ativo' : '') + '" data-cat="" role="tab">Tudo</button>' +
      cats.map(function (c, i) {
        var extra = i >= LIMITE && estado.categoria !== c;
        return '<button type="button" class="glimmer-cat__chip' + (estado.categoria === c ? ' is-ativo' : '') + (extra ? ' is-extra' : '') + '" data-cat="' + esc(c) + '" role="tab">' + esc(c) + '</button>';
      }).join('') +
      (cats.length > LIMITE ? '<button type="button" class="glimmer-cat__chip glimmer-cat__chip--mais" data-cat-mais-cats>' + (estado.todasCats ? 'Menos' : 'Mais categorias') + '</button>' : '');
    var caixa = $('[data-cat-chips]');
    caixa.innerHTML = html;
    caixa.classList.toggle('is-aberto', Boolean(estado.todasCats));
    var ativo = caixa.querySelector('.is-ativo');
    if (ativo && estado.categoria && caixa.scrollWidth > caixa.clientWidth) { caixa.scrollTo({ left: ativo.offsetLeft - 16, behavior: 'smooth' }); }
  }

  function cartao(p) {
    var parcela = p.preco / FATOR / PARCELAS;
    return '<li class="glimmer-cat__item"><a class="glimmer-cat__card" href="/products/' + esc(p.handle) + '">' +
      '<span class="glimmer-cat__foto">' + (p.img ? '<img src="' + esc(foto(p.img)) + '" alt="" loading="lazy" width="240" height="240">' : '') + '</span>' +
      '<span class="glimmer-cat__marca">' + esc(p.marca) + '</span>' +
      '<span class="glimmer-cat__nome">' + esc(p.nome) + '</span>' +
      '<span class="glimmer-cat__preco">' + (p.varios ? '<small>a partir de</small> ' : '') + dinheiro(p.preco) + '</span>' +
      (p.preco > 0 ? '<span class="glimmer-cat__parcela">ou ' + PARCELAS + 'x de ' + dinheiro(Math.floor(parcela * 100) / 100) + ' sem juros</span>' : '') +
      '</a></li>';
  }

  function ativos() {
    var itens = [];
    if (estado.q) { itens.push(['q', '“' + estado.q + '”']); }
    if (estado.marca) { itens.push(['marca', estado.marca]); }
    var el = $('[data-cat-ativos]');
    el.hidden = !itens.length;
    el.innerHTML = itens.map(function (i) { return '<button type="button" data-tirar="' + i[0] + '">' + esc(i[1]) + ' <span aria-hidden="true">&times;</span></button>'; }).join('');
  }

  // Faixa "Não achou? A gente traz" no meio da grade (depois da 8ª foto), ocupando a linha toda.
  var ENC_POS = 8;
  var encomenda = '<li class="glimmer-cat__enc"><a href="/search?view=encomenda">' +
    'Não achou o que procura? <u>A gente traz pra você</u></a></li>';

  // Mostra os próximos produtos sem refazer a lista (rolagem contínua).
  function acrescentar() {
    var grade = $('[data-cat-grade]');
    var ja = grade.querySelectorAll('.glimmer-cat__item').length;
    var novos = listaAtual.slice(ja, estado.mostrar);
    if (novos.length) { grade.insertAdjacentHTML('beforeend', novos.map(cartao).join('')); }
    $('[data-cat-carregando]').hidden = listaAtual.length <= estado.mostrar;
  }

  function render() {
    estado.mostrar = POR_VEZ;
    listaAtual = ordenar(filtrados(false));
    var grade = $('[data-cat-grade]');
    grade.classList.remove('is-entrando');
    var cartoes = listaAtual.slice(0, estado.mostrar).map(cartao);
    if (cartoes.length) { cartoes.splice(Math.min(ENC_POS, cartoes.length), 0, encomenda); }
    grade.innerHTML = cartoes.join('');
    void grade.offsetWidth;   // reinicia a animação de entrada
    grade.classList.add('is-entrando');
    $('[data-cat-vazio]').hidden = listaAtual.length > 0;
    $('[data-cat-carregando]').hidden = listaAtual.length <= estado.mostrar;
    $('[data-cat-marca]').value = estado.marca;
    $('[data-cat-ordem]').value = estado.ordem;
    chips();
    ativos();
    gravarUrl();
  }

  function marcas() {
    var lista = [];
    var vistas = {};
    produtos.forEach(function (p) { var k = p.marca.toLowerCase(); if (p.marca && !vistas[k]) { vistas[k] = true; lista.push(p.marca); } });
    lista.sort(function (a, b) { return a.localeCompare(b, 'pt-BR', { sensitivity: 'base' }); });
    $('[data-cat-marca]').innerHTML = '<option value="">Todas</option>' + lista.map(function (m) { return '<option>' + esc(m) + '</option>'; }).join('');
  }

  // Eventos
  $('[data-cat-marca]').addEventListener('change', function (e) { estado.marca = e.target.value; render(); });
  $('[data-cat-ordem]').addEventListener('change', function (e) { estado.ordem = e.target.value; render(); });
  raiz.addEventListener('click', function (e) {
    if (e.target.closest('[data-cat-mais-cats]')) { estado.todasCats = !estado.todasCats; chips(); return; }
    var chip = e.target.closest('[data-cat]');
    if (chip) { estado.categoria = chip.getAttribute('data-cat'); render(); return; }
    var tirar = e.target.closest('[data-tirar]');
    if (tirar) { estado[tirar.getAttribute('data-tirar')] = ''; render(); return; }
    if (e.target.closest('[data-cat-limpar]')) { estado.q = ''; estado.categoria = ''; estado.marca = ''; render(); }
  });

  // Rolagem contínua: perto do fim da lista, carrega mais 24.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) {
      if (entradas.some(function (x) { return x.isIntersecting; }) && listaAtual.length > estado.mostrar) { estado.mostrar += POR_VEZ; acrescentar(); }
    }, { rootMargin: '600px 0px' }).observe($('[data-cat-fim]'));
  }

  lerUrl();
  var pedirRelevancia = fetch('https://glimmer-checkout.vercel.app/api/relevancia').then(function (r) { return r.json(); })
    .then(function (d) { relevancia = { vendas: (d && d.vendas) || {}, vistas: (d && d.vistas) || {} }; }).catch(function () {});
  Promise.all([buscar(1, []), pedirRelevancia]).then(function (res) {
    produtos = res[0].filter(function (p) { return !/teste/i.test(p.handle || ''); }).map(preparar);
    marcas();
    // Marca vinda do endereço com grafia diferente (ex.: "tarte"): usa a da lista.
    if (estado.marca) { var m = produtos.find(function (p) { return p.marca.toLowerCase() === estado.marca.toLowerCase(); }); estado.marca = m ? m.marca : ''; }
    render();
  }).catch(function () { $('[data-cat-grade]').innerHTML = '<li class="glimmer-cat__erro">Não conseguimos carregar os produtos. Recarregue a página.</li>'; });
})();
